// export const ADMINURI = "https://dev-api.bithappier.com/admin-module/";
// export const APIURI = "https://dev-api.bithappier.com/user-module/";
// export const Community = "https://dev-api.bithappier.com/community-module/";
// export const CommunityURI = "https://dev-api.bithappier.com/community-module/";
// export const NftMarketplace =
//   "https://dev-api.bithappier.com/nft-marketplace-module";
// export const APICORPORATE = "https://dev-api.bithappier.com/corporate-module/";
// export const AI_CHATBOT_URI = "https://ai.bithappier.com";

// let domain = "https://stage-v2-api.bithappier.com";


// let domain = "http://localhost:8091";
// export const ADMINURI = `${domain}/`;
// export const APIURI = `${domain}/`;
// export const Community = `http://localhost:8093/`;
// export const CommunityURI = `http://localhost:8093/`;
// export const NftMarketplace = `http://localhost:8095`;
// export const APICORPORATE = `http://localhost:8094/`;


let domain = "https://api.bithappier.com";
export const ADMINURI = `${domain}/admin-module/`;
export const APIURI = `${domain}/user-module/`;
export const Community = `${domain}/community-module/`;
export const CommunityURI = `${domain}/community-module/`;
export const NftMarketplace = `${domain}/nft-marketplace-module`;
export const APICORPORATE = `${domain}/corporate-module/`;


// prod/staging ai url
export const AI_CHATBOT_URI = "https://aiprod.bithappier.com";

export const apiConfig = {
  headers: {
    "Content-Type": "application/json",
    // Authorization: localStorage.getItem("jwtToken"),
    "Cache-Control": "no-cache, no-store",
    Pragma: "no-cache", // HTTP 1.0 compatibility
    Expires: "0", // Ensures the response expires immediately
  },
  withCredentials: true, // Include cookies in the request
};

// {
//    headers: { Authorization: `Bearer ${result1}` }
// }

//  {
//    headers: { Authorization: `Bearer ${token}` },
//    withCredentials: true,
//    credentials: "include",
//  }

// export const ADMINURI = "https://dev-api.bithappier.com/admin-module/";
// export const APIURI = "https://dev-api.bithappier.com/user-module/";
// export const Community = "https://dev-api.bithappier.com/community-module/";
// export const CommunityURI = "https://dev-api.bithappier.com/community-module/";
// export const NftMarketplace =
//   "https://dev-api.bithappier.com/nft-marketplace-module";

// --openssl-legacy-provider
